"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _DbUser = _interopRequireDefault(require("../model/DbUser"));

var _UserCredentials = _interopRequireDefault(require("../model/UserCredentials"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* AuthenticationService service.
* @module api/AuthenticationServiceApi
* @version 2.1.1
*/
var AuthenticationServiceApi = /*#__PURE__*/function () {
  /**
  * Constructs a new AuthenticationServiceApi. 
  * @alias module:api/AuthenticationServiceApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AuthenticationServiceApi(apiClient) {
    _classCallCheck(this, AuthenticationServiceApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * add a user
   * @param {module:model/DbUser} dbUser user
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
   */


  _createClass(AuthenticationServiceApi, [{
    key: "addUserWithHttpInfo",
    value: function addUserWithHttpInfo(dbUser) {
      var postBody = dbUser; // verify the required parameter 'dbUser' is set

      if (dbUser === undefined || dbUser === null) {
        throw new Error("Missing the required parameter 'dbUser' when calling addUser");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/users', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * add a user
     * @param {module:model/DbUser} dbUser user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "addUser",
    value: function addUser(dbUser) {
      return this.addUserWithHttpInfo(dbUser).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * change display name
     * @param {String} username username
     * @param {String} body displayname
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "changeDisplayNameWithHttpInfo",
    value: function changeDisplayNameWithHttpInfo(username, body) {
      var postBody = body; // verify the required parameter 'username' is set

      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling changeDisplayName");
      } // verify the required parameter 'body' is set


      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling changeDisplayName");
      }

      var pathParams = {
        'username': username
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['text/plain'];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/users/{username}/displayname', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * change display name
     * @param {String} username username
     * @param {String} body displayname
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "changeDisplayName",
    value: function changeDisplayName(username, body) {
      return this.changeDisplayNameWithHttpInfo(username, body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * change email
     * @param {String} username username
     * @param {String} body email
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "changeEmailWithHttpInfo",
    value: function changeEmailWithHttpInfo(username, body) {
      var postBody = body; // verify the required parameter 'username' is set

      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling changeEmail");
      } // verify the required parameter 'body' is set


      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling changeEmail");
      }

      var pathParams = {
        'username': username
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['text/plain'];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/users/{username}/email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * change email
     * @param {String} username username
     * @param {String} body email
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "changeEmail",
    value: function changeEmail(username, body) {
      return this.changeEmailWithHttpInfo(username, body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * change password
     * @param {String} username username
     * @param {String} body password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "changePasswordWithHttpInfo",
    value: function changePasswordWithHttpInfo(username, body) {
      var postBody = body; // verify the required parameter 'username' is set

      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling changePassword");
      } // verify the required parameter 'body' is set


      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling changePassword");
      }

      var pathParams = {
        'username': username
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['text/plain'];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/users/{username}/password', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * change password
     * @param {String} username username
     * @param {String} body password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "changePassword",
    value: function changePassword(username, body) {
      return this.changePasswordWithHttpInfo(username, body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * delete a user
     * @param {String} username username
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "deleteUserWithHttpInfo",
    value: function deleteUserWithHttpInfo(username) {
      var postBody = null; // verify the required parameter 'username' is set

      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling deleteUser");
      }

      var pathParams = {
        'username': username
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/users/{username}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * delete a user
     * @param {String} username username
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "deleteUser",
    value: function deleteUser(username) {
      return this.deleteUserWithHttpInfo(username).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * get display name
     * @param {String} username username
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "getDisplayNameWithHttpInfo",
    value: function getDisplayNameWithHttpInfo(username) {
      var postBody = null; // verify the required parameter 'username' is set

      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getDisplayName");
      }

      var pathParams = {
        'username': username
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/users/{username}/displayname', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * get display name
     * @param {String} username username
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "getDisplayName",
    value: function getDisplayName(username) {
      return this.getDisplayNameWithHttpInfo(username).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * get email
     * @param {String} username username
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "getEmailWithHttpInfo",
    value: function getEmailWithHttpInfo(username) {
      var postBody = null; // verify the required parameter 'username' is set

      if (username === undefined || username === null) {
        throw new Error("Missing the required parameter 'username' when calling getEmail");
      }

      var pathParams = {
        'username': username
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/users/{username}/email', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * get email
     * @param {String} username username
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "getEmail",
    value: function getEmail(username) {
      return this.getEmailWithHttpInfo(username).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * get service information
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "getRootInfoWithHttpInfo",
    value: function getRootInfoWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * get service information
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "getRootInfo",
    value: function getRootInfo() {
      return this.getRootInfoWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * get the usernames
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<String>} and HTTP response
     */

  }, {
    key: "getUsernamesWithHttpInfo",
    value: function getUsernamesWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = ['String'];
      return this.apiClient.callApi('/auth/rest/users', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * get the usernames
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<String>}
     */

  }, {
    key: "getUsernames",
    value: function getUsernames() {
      return this.getUsernamesWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * log in
     * @param {module:model/UserCredentials} userCredentials user credentials
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "loginWithHttpInfo",
    value: function loginWithHttpInfo(userCredentials) {
      var postBody = userCredentials; // verify the required parameter 'userCredentials' is set

      if (userCredentials === undefined || userCredentials === null) {
        throw new Error("Missing the required parameter 'userCredentials' when calling login");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/login', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * log in
     * @param {module:model/UserCredentials} userCredentials user credentials
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "login",
    value: function login(userCredentials) {
      return this.loginWithHttpInfo(userCredentials).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * refresh token
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link String} and HTTP response
     */

  }, {
    key: "refreshTokenWithHttpInfo",
    value: function refreshTokenWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = 'String';
      return this.apiClient.callApi('/auth/rest/refresh', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * refresh token
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link String}
     */

  }, {
    key: "refreshToken",
    value: function refreshToken() {
      return this.refreshTokenWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return AuthenticationServiceApi;
}();

exports["default"] = AuthenticationServiceApi;